var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_76_7",
    "data-name": "Component 76 \\u2013 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "star__bg",
    d: "M 34.89705276489258 41.74485015869141 L 23.80596923828125 34.67884826660156 L 23 34.16537857055664 L 22.19403076171875 34.67884826660156 L 11.10294532775879 41.74485015869141 L 14.22507953643799 28.64348030090332 L 14.43558025360107 27.76016998291016 L 13.75053024291992 27.16414070129395 L 3.691597938537598 18.41214179992676 L 16.78870964050293 17.41643905639648 L 17.72304916381836 17.34540939331055 L 18.06901931762695 16.47458076477051 L 23 4.062729358673096 L 27.93098068237305 16.47456932067871 L 28.27695083618164 17.34539985656738 L 29.21129035949707 17.41642951965332 L 42.30840301513672 18.41213989257812 L 32.24946975708008 27.16414070129395 L 31.56442070007324 27.76016998291016 L 31.7749195098877 28.64348030090332 L 34.89705276489258 41.74485015869141 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "star__outline",
    d: "M 23 8.125450134277344 L 18.77111053466797 18.77005958557129 L 7.383220672607422 19.63582229614258 L 16.10519981384277 27.22459030151367 L 13.42066192626953 38.48972320556641 L 23 32.3868293762207 L 32.5793342590332 38.48971939086914 L 29.89477920532227 27.22459030151367 L 38.61677932739258 19.63581848144531 L 27.22888946533203 18.77005004882812 L 23 8.125450134277344 M 23 0 L 29.32500076293945 15.92074966430664 L 46 17.1884708404541 L 33.23406219482422 28.2957592010498 L 37.21477890014648 45 L 23 35.94393157958984 L 8.785221099853516 45 L 12.76593017578125 28.2957592010498 L 0 17.1884708404541 L 16.67499923706055 15.9207592010498 L 23 0 Z",
    stroke: "none",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ab73c3b3.svg";
export { ForwardRef as ReactComponent };